import React, { Component } from 'react';
import '../../App.css';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import calculatePrice from '../../util/calculatePrice';
import classname from 'classnames';
import {getUserSession} from '../../actions/user';
import { logout } from '../../actions/user';

class TopNav extends Component{
  constructor(props) {
    super(props);
    this.getUserSession();
    this.state = { navClass:  "collapse navbar-collapse", mblOpen: false} ;
  }
  getUserSession(){
    console.log('getting user session');
    this.props.dispatch(getUserSession());
  }
  toggleNav() {
    var navClass = "collapse navbar-collapse in";
    if(this.state.navClass.indexOf(' in') > 0) {
      navClass = "collapse navbar-collapse";
    }
    this.setState({navClass: navClass});
  }
  Logout(){
    //this.props.dispatch(logout());
    this.props.dispatch(
      logout(() => {
        console.log("got to callback of logout");
        window.location.href = "https://editmypaper.ca/";
      })
    )
  }
  setMblOpen() {
    console.log("called and current value is ",this.state.mblOpen);
    let flip = !this.state.mblOpen;
    console.log("new value is going to be ", flip);
    this.setState({mblOpen: flip});
  }
  render() {
    var active_Next = classname({
      'button': true,
      'next'  : true,
      'inactive-next': !(this.props.User.loggedin)
    });
    var dropdownMenuClass = (this.state.mblOpen)? "topnav-dropdown-open": "topnav-dropdown-closed";
    var targetAttrib = "_self";
    if(this.props && this.props.inSteps) {
      targetAttrib = "linkFromSteps";
    }
    var navUlClasses = "nav navbar-nav";
    if(!this.props.inSteps && !this.props.mobileSupported) {
      navUlClasses = navUlClasses + " nomobile"
    }
    return (
      <div>
        <header className="header">
          <div className="container">
            <div className="row">
              <nav className="navbar ">
                <div className="container-fluid">
                  <div className="navbar-header">
                    <a className="navbar-brand" href="https://editmypaper.ca/" target={targetAttrib}><img src="/checkout_files/logo.png" className="logo" alt="Edit_My_Paper_logo" /></a>
                    <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#myNavbar" onClick={this.toggleNav.bind(this)}>
                      <div id="fancy_icon-505-7" >
                        <svg id="svg-fancy_icon-505-7">
                            <svg id="Lineariconsicon-menu-circle" viewBox="0 0 20 20">
                              <path d="M9.5 20c-2.538 0-4.923-0.988-6.718-2.782s-2.782-4.18-2.782-6.717c0-2.538 0.988-4.923 2.782-6.718s4.18-2.783 6.718-2.783c2.538 0 4.923 0.988 6.718 2.783s2.782 4.18 2.782 6.718-0.988 4.923-2.782 6.717c-1.794 1.794-4.18 2.782-6.718 2.782zM9.5 2c-4.687 0-8.5 3.813-8.5 8.5s3.813 8.5 8.5 8.5 8.5-3.813 8.5-8.5-3.813-8.5-8.5-8.5z"></path>
                              <path d="M14.5 8h-10c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h10c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                              <path d="M14.5 11h-10c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h10c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                              <path d="M14.5 14h-10c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h10c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                            </svg>
                        </svg>
                      </div>
                    </button>
                  </div>
                  <div className={this.state.navClass}>
                    {(this.props.inSteps || this.props.mobileSupported) &&
                    <div className="mblMenuBackDrop"></div>}
                    <ul className={navUlClasses}>
                      {(this.props.inSteps || this.props.mobileSupported) &&
                      <li className="mobileNavCloseHolder">
                        <img id="image-488-7" width="120px" alt="" src="checkout_files/logo-menu.png"  />
                        <a href="JavaScript: void(0);" onClick={this.toggleNav.bind(this)} role="button" title="Close">
                          <span></span>
                          <svg id="mobileNavClose" >
                            <svg id="Lineariconsicon-cross" viewBox="0 0 20 20">
                              <path d="M10.707 10.5l5.646-5.646c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.646 5.646-5.646-5.646c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l5.646 5.646-5.646 5.646c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l5.646-5.646 5.646 5.646c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146c0.195-0.195 0.195-0.512 0-0.707l-5.646-5.646z"></path>
                            </svg>
                          </svg>
                        </a>
                      </li>}
                      <li className="active"><a href="/get-started">Submit Your Paper</a></li>
                      {(this.props.inSteps || this.props.mobileSupported) && 
                      <li className="topnav-dropdown">
                        <a href="#" onClick={this.setMblOpen.bind(this)} >Proofreading &amp; Editing Services</a>
                        <div className="topnav-dropdown-mobile-arrow mobile-only">
                          <svg id="svg-fancy_icon-584-7">
                            <svg id="FontAwesomeicon-angle-down" viewBox="0 0 18 28"><path d="M16.797 11.5c0 0.125-0.063 0.266-0.156 0.359l-7.281 7.281c-0.094 0.094-0.234 0.156-0.359 0.156s-0.266-0.063-0.359-0.156l-7.281-7.281c-0.094-0.094-0.156-0.234-0.156-0.359s0.063-0.266 0.156-0.359l0.781-0.781c0.094-0.094 0.219-0.156 0.359-0.156 0.125 0 0.266 0.063 0.359 0.156l6.141 6.141 6.141-6.141c0.094-0.094 0.234-0.156 0.359-0.156s0.266 0.063 0.359 0.156l0.781 0.781c0.094 0.094 0.156 0.234 0.156 0.359z"></path></svg>
                          </svg>
                        </div>
                        <ul className={dropdownMenuClass}>
                        <li><a href="https://editmypaper.ca/essay-editing-service">Essay</a></li>
                        <li><a href="https://editmypaper.ca/paper-editing-service">Paper</a></li>
                        <li><a href="https://editmypaper.ca/thesis-editing-service">Thesis</a></li>
                        <li><a href="https://editmypaper.ca/dissertation-editing-service">Dissertaion</a></li>
                        <li><a href="https://editmypaper.ca/personal-statement-editing">Personal Statement</a></li>
                        <li><a href="https://editmypaper.ca/citation-editing-service">Citation Editing</a></li>
                        <li><a href="https://editmypaper.ca/document-formatting-service">Document Formatting<span className="desktop-only"> (APA,MLA+)</span></a></li>
                        <li><a href="https://editmypaper.ca/proofreading-service/">Proofreading Service</a></li>
                        </ul>
                      </li>
                      }
                      <li><a href="https://editmypaper.ca/guarantee/" target={targetAttrib}>Guarantee</a></li>
                      <li><a href="https://editmypaper.ca/faq/" target={targetAttrib}>FAQ</a></li>
                      <li><a href="https://editmypaper.ca/edit-tiers/" target={targetAttrib}>Examples</a></li>
                      {(this.props.User.role === "student") && <li><Link to="/studentdashboard" target={targetAttrib}>My Account</Link></li>}
                      {(this.props.User.role === "editor") && <li><Link to="/editordashboard">Dashboard</Link></li>}
                      {(this.props.User.role === "admin") && <li><Link to="/admindashboard">Admin Dashboard</Link></li>}
                      {this.props.User.loggedin && <li><a href="#" onClick={this.Logout.bind(this)}>Logout</a></li>}
                      {!this.props.User.loggedin && <li><a href="/login">Login</a></li>}
                    </ul>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </header>
        </div>
      )
    }
}

export default connect(
  ({User, Dashboard})=>({User, Dashboard})
)(TopNav);

// {!this.props.User.loggedin && <li><Link to="/register">Register</Link></li>}



// WEBPACK FOOTER //
// ./src/components/includes/TopNav.js